import Headcom from "../../src/components/Headcom";
import FooterCom from "../../src/components/FooterCom";
import CookieCom from "../../src/components/CookieCom";
import { PageList } from "../../src/list/PageList";
import { Assets } from "../../src/list/Assets";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Link from "next/link";
import Snow_fx from "../../src/fx/Snow_fx";
import Image from "next/image";

export default function ContactUs() {
  const path = useRouter();

  useEffect(() => {}, []);
  async function handleOnSubmit(e) {
    e.preventDefault();
    const formData = {};
    Array.from(e.currentTarget.elements).forEach((field) => {
      if (!field.name) return;
      formData[field.name] = field.value;
    });
    fetch("../api/mail", {
      method: "post",
      body: JSON.stringify(formData),
    });
  }

  return (
    <>
      <Headcom
        title={PageList[3].title}
        s_dis={PageList[3].s_dis}
        path={PageList[3].path[1] + PageList[3].path[0]}
        thumb={PageList[3].thumb}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
      <div className="app_cont">
        <div className="contact_form">
          <div className="contact_container_temp">
            <h1>Contact Us</h1>
            <Link href={"/"}  className="contact_logo_2_temp" passHref>
                <Image
                  decoding="async"
                  alt="Logo"
                  title="logo"
                  src={Assets[0].logo2}
                  fill 
                  className="unset_position"
                ></Image>
            </Link>
            <div className="brand_info">
              Playcutegames.com would love to hear what you think about our
              website. Any comments, questions, or complaints are always
              welcomed! We love complaints because it helps us improve our
              website. However, we also love compliments because it keeps us
              motivated to keep doing what we are doing!
            </div>
            <div className="brand_info">
              For all questions,{"\n"} please contact
              <Link href={"https://fabboxstudios.com/contact-us/"} target={"_blank"} passHref>
                admin@fabboxstudios.com
              </Link>
            </div>

            <div className="brand_info">Powered by Fabbox Studios</div>
          </div>
         
        </div>
        <CookieCom />
      </div>
      <FooterCom />
      <Snow_fx />
    </>
  );
}
